import React from 'react'
import { Modal, Row, Space } from 'antd'
import { ButtonEx } from '../../HeroLocations/index.style'

const BinDelete = (props) => {
  const { visible, onCancel, onOk } = props
  return (
    <Modal
      title="ยืนยัน"
      visible={visible}
      onCancel={onCancel}
      onOk={onOk}
      footer={null}>
      <p>คุณยืนยันจะลบข้อมูลถังขยะของคุณ ?</p>
      <p style={{ color: 'red' }}>
        การลบข้อมูลถังขยะจะทำให้ข้อมูลการทิ้งสูญหาย
      </p>
      <Row justify="end">
        <Space>
          <ButtonEx onClick={() => onCancel()}>ยกเลิก</ButtonEx>
          <ButtonEx color="#6ebf4b" type="primary" onClick={() => onOk()}>
            ยืนยัน
          </ButtonEx>
        </Space>
      </Row>
    </Modal>
  )
}

export default BinDelete



// WEBPACK FOOTER //
// ./src/pages/AccountBin/BinDelete/index.js